<h2 mat-dialog-title>Pré-visualização da declaração</h2>

<mat-dialog-content>
  <div class="preview-wrapper">
    <div class="preview-document" [innerHTML]="safeHtml"></div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()">Voltar</button>
  <button mat-raised-button color="primary" (click)="confirmar()">
    <mat-icon>download</mat-icon>
    Confirmar e Baixar
  </button>
</mat-dialog-actions>
